import {Injectable, OnDestroy} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {UserService} from '../services/user/user.service';
import {ISubscription} from 'rxjs-compat/Subscription';
import {User} from '../services/user/user';

@Injectable()
export class AuthGuard  implements OnDestroy {

    currentUrl: any;
    currentUser: User | any;
    private user_subscription: ISubscription;

    constructor(private router: Router, private userService: UserService) {
        router.events.subscribe((val) => {
            this.currentUrl = location.pathname;
        });
        // this method is used to get the user details, instead of calling to server every time, by using behavioural subject
        this.user_subscription =  this.userService.getCurrentUserObservable().subscribe(currentUser => {
            this.currentUser = currentUser;
        }, (error) => {
            console.log(error);
        });
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // checking if user is login
        if (this.isLoggedIn()) {
            // logged in so return true
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }

    /**
     * checking if user is logged in
     */
    isLoggedIn() {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        return this.currentUser !== null && this.currentUser !== undefined  && this.currentUser.id !== null && this.currentUser.id !== undefined && this.currentUrl !== '/404' && this.currentUrl !== '/';
    }

    /**
     * destroying the subscription
     */
    ngOnDestroy(): void {
        this.user_subscription.unsubscribe();
    }

}
